import { Card, Divider, Stack, Box } from '@mui/material';
import { HeroMetricProps } from './Summary/HeroMetric';

export type AdSpendCardProps = {
  color: HeroMetricProps['colorScheme'];
  metrics: {
    render: () => React.ReactNode;
    key: string;
  }[];
  children?: React.ReactNode;
};

export const AdSpendCard = (props: AdSpendCardProps) => {
  return (
    <Card sx={{ padding: '1rem', minWidth: 380, height: '100%' }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>{props.children}</Box>

        <Divider orientation="vertical" flexItem />

        <Stack direction="row" spacing={2} flex={2}>
          {props.metrics.map(metric => (
            <Box key={metric.key} flex={1}>
              <metric.render />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
};
